import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import { PathNames } from "application/routes";
import { useAppSelector } from "application/store";
import { requestSelector } from "application/store/request/selectors";
import { AmplitudeEvent, useAmplitude } from "application/hooks/useAmplitude";
import { QAAdditionalButtonState, QARequestButtonState } from "integration/api/Deal/models";

import QAButton from "../QAButton";
import QuestionForQAModal from "features/question-answer/modals/QuestionForQAModal";
import RegistrationForQAModal from "features/question-answer/modals/RegistrationForQAModal";

import { ChatButton, Container } from "./styles";
import { ReactComponent as ChatIcon } from "./assets/chat.svg";

const QuestionAnswer = () => {
  const navigate = useNavigate();
  const { trackEvent } = useAmplitude();
  const requests = useAppSelector(requestSelector);
  const { deal } = useAppSelector((state) => state.deal);
  const [questionModal, setQuestionModal] = useState(false);
  const [registerModal, setRegisterModal] = useState(false);

  const deal_title = deal?.title;
  const showAdditionalButton = deal?.additionalQaButtonState !== QAAdditionalButtonState.HIDDEN;

  const openRegisterModal = () => {
    setRegisterModal(true);
    trackEvent(AmplitudeEvent["Deals_Q&A_In_button"], { deal_title });
  };

  const closeRegisterModal = () => {
    setRegisterModal(false);
  };

  const toggleQuestionModal = () => {
    setQuestionModal((prev) => !prev);
  };

  const viewSession = () => {
    const link = deal?.overview.videos?.find((x) => x.deepDiveVideo);
    link && window.open(link.url, "_blank");
  };

  const navigateQuestionAnswer = () => {
    navigate(PathNames.questionAnswer);
  };

  const onClick = () => {
    switch (deal?.requestQaButtonState) {
      case QARequestButtonState.INITIAL:
        openRegisterModal();
        break;
      case QARequestButtonState.VIEW_ANSWER:
      case QARequestButtonState.VIEW_QUESTION:
        navigateQuestionAnswer();
        break;
      case QARequestButtonState.VIEW_QA_SESSION:
        viewSession();
        break;
    }
  };

  return (
    <React.Fragment>
      <Container>
        <QAButton onClick={onClick} state={deal?.requestQaButtonState} />
        {showAdditionalButton && (
          <ChatButton onClick={navigateQuestionAnswer}>
            <ChatIcon />
          </ChatButton>
        )}
      </Container>
      <QuestionForQAModal
        deal={deal}
        visible={questionModal}
        loading={requests.registerWebinarQuestion.loading}
        onClose={toggleQuestionModal}
      />
      <RegistrationForQAModal
        deal={deal}
        visible={registerModal}
        loading={requests.registerWebinar.loading}
        onClose={closeRegisterModal}
        toggleQuestionModal={toggleQuestionModal}
      />
    </React.Fragment>
  );
};

export default QuestionAnswer;
